module.exports = __webpack_public_path__ + "img/39exp.29f62b6c.jpg";